export default class DadosDasReceitas {
    constructor(formulario = '') {
        this.retiradaDoProdutorMes = formulario.retiradaDoProdutorMes == undefined ? 0 : formulario.retiradaDoProdutorMes;
        this.retiradaDoProdutorDedicacaoBovinocultura = formulario.retiradaDoProdutorDedicacaoBovinocultura == undefined ? 0 : formulario.retiradaDoProdutorDedicacaoBovinocultura;
        this.retiradaFamiliaMes = formulario.retiradaFamiliaMes == undefined ? 0 : formulario.retiradaFamiliaMes;
        this.retiradaFamiliaDedicacaoBovinocultura = formulario.retiradaFamiliaDedicacaoBovinocultura == undefined ? 0 : formulario.retiradaFamiliaDedicacaoBovinocultura;
    }
}